
import * as THREE from 'three'
import { useFrame, useThree } from "@react-three/fiber"
import { useRef, useState } from 'react';


const GridFloor = ({size, divisions, backgroundColor}) =>{
const gridHelperRef = useRef()
const { camera, gl, scene } = useThree()

useFrame((state,delta)=>{
    gridHelperRef.current.rotation.y -= delta * 0.05
})

return <mesh scale={12}>
    <gridHelper ref={gridHelperRef}  args={[8,32,'#ea2cc7','#521696']}/>
</mesh>
}

export default GridFloor